import { CssBaseline, ThemeProvider } from '@mui/material'
import type { ReactNode } from 'react'
import { theme } from './theme'

export const AppThemeProvider = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
)
